export interface SpaTreatment {
  name: string;
  duration: string;
  price: string;
  description: string;
}

export interface SpaCategory {
  title: string;
  items: SpaTreatment[];
}

export const spaData: SpaCategory[] = [
  {
    title: "Body Massage",
    items: [
      {
        name: "Balinese Massage",
        duration: "60 minutes / 90 minutes",
        price: "IDR 295K / IDR 415K",
        description: "Authentic traditional Massage its combined with Balinese technique, stretching, long stroke skin rolling, palm, thumbs pressure techniques to balance the energy centers and improve the integration of your internal systems, blood circulation and release stress."
      },
      {
        name: "Frequent Flyer Massage",
        duration: "45 Minutes",
        price: "IDR 265K",
        description: "This is the perfect cure after long flight, to relieve tensions. It consists of a condensed but complete head, neck and shoulder massage using our special blend of oils, concluded with warm towel application. (Head, neck, and shoulder massage, warm towel)"
      },
      {
        name: "Therapeutic Sport Massage",
        duration: "60 Minutes",
        price: "IDR 435K",
        description: "This deep tissue massage is a ideal for increasing circulation, assisting with healing injuries, and creating a very deep sense of relaxation in the body. (Foot wash, body massage)"
      },
      {
        name: "Durma Healthy Massage",
        duration: "90 Minutes",
        price: "IDR 490K",
        description: "Indulge in the ultimate massage experience commencing with a luxurious, begin with mineral and traditional Balinese foot bath, followed Patal kikian massage with the unique dancing finger movement, assist with eliminating reflexology relaxing. (Foot wash using traditional Balinese foot bath, body massage with foot reflex)"
      },
      {
        name: "Aromatherapy Massage",
        duration: "60 Minutes",
        price: "IDR 335K",
        description: "A relaxing massage involving a variety of techniques, essential oil is applied in long sweeping strokes which warm up the skin and muscles, the essential experience is completed with an oil burner that enhances the benefits of those oils extracted from herbs and plants. (Foot wash, body massage with warm oil)."
      }
    ]
  },
  {
    title: "Specialty Treatments",
    items: [
      {
        name: "Patal kikian Stone Massage",
        duration: "90 Minutes",
        price: "IDR 480K",
        description: "A nature therapy warm stone are using typically river rock stone, heated in sanitizing water to give beneficial muscle relaxing, improved circulation and pain relief. (Foot wash, and stone massage)."
      },
      {
        name: "Massage Reflexology",
        duration: "60 Minutes",
        price: "IDR 325K",
        description: "An ancient Chinese healing art focused on the pressure point in the feet that correspond with organs and muscles of body, Including a hand reflexology for improves circulation and general wellness. (Foot wash, foot massage and hand massage)."
      },
      {
        name: "Flower Bath",
        duration: "30 Minutes",
        price: "IDR 250K",
        description: "A Traditional holds that bathing in the frequency or energy of blooms quite literally support the blossoming and flourishing of life, it is a healing practice that we assist to remove emotional obstacles and enhance your aura with natural flower vitality increase positive energy and good fortune."
      },
      {
        name: "Nail Gel Polish",
        duration: "60 Minutes",
        price: "IDR 285K",
        description: "Gel Nails refer to a type of nail polish that is cured with a UV nail lamp to create a shiny, long-lasting manicure or pedicure that doesn't require extensive time to dry."
      },
      {
        name: "Foot Massage",
        duration: "30 Minutes",
        price: "IDR 199K",
        description: "A foot massage is focused mainly on the muscles located around the front and back on the feet. A foot massage involves a range of techniques, each used to decrease pain, relieve tension and improve blood circulation."
      }
    ]
  },
  {
    title: "Body Scrub and Mask",
    items: [
      {
        name: "Boreh Scrub & Mask",
        duration: "60 Minutes",
        price: "IDR 335K",
        description: "Traditional herbal blend gently buffs, nourish, revitalize and give a glow to the skin."
      },
      {
        name: "Chocolate Scrub & Mask",
        duration: "60 Minutes",
        price: "IDR 335K",
        description: "A moisturizing scrub with a cocoa extracts to eliminate impurities, exfoliate and moisturizing the skin."
      },
      {
        name: "Coconut Scrub & Mask",
        duration: "60 Minutes",
        price: "IDR 335K",
        description: "A moisturizing scrub with a green tea extracts to eliminate impurities, exfoliate and moisturizing the skin."
      }
    ]
  },
  {
    title: "Esthetics Treatment",
    items: [
      {
        name: "Signature Treatment",
        duration: "60 Minutes",
        price: "IDR 335K",
        description: "A stimulating facial experience combining completely edible, nature organic ingredients and extracts, with a gentle acupressure massage of energy point of the face, assisting with releasing toxins and revitalizing delicate of the skin. This unique facial experience will leave you feeling clean refreshed."
      },
      {
        name: "Patal kikian manicure",
        duration: "60 minutes",
        price: "IDR 285K",
        description: "Luxurious conditioning cares for your hands. More youthful hands through nail filling, cuticle trimming and minimizing, with exploitation to the hands massage. Allowing the hands to appear softer and smoother."
      },
      {
        name: "Patal kikian pedicure",
        duration: "60 minutes",
        price: "IDR 285K",
        description: "Pampering time for your feet, we begin with an aromatic foot soak and scrub. Filling cuticle minimizing, pampering foot or leg massage to enhance the condition of your beautiful feet."
      }
    ]
  },
  {
    title: "Body Packages",
    items: [
      {
        name: "Nilotama Beauty",
        duration: "120 Minutes",
        price: "IDR 585K",
        description: "Treat yourself to this unique experience and indulge your body and soul with a therapeutic sport massage for begin relieve the muscles tension with a deep tissue techniques, followed by a signature facial for complete you indulge experience will leave you feeling totally clean and refreshed. (Foot wash, sport massage, and signature facial)."
      },
      {
        name: "Gangga Mayang Beauty",
        duration: "120 Minutes",
        price: "IDR 735K",
        description: "This treatment is the perfect way to end a perfect day, begin with a aromatherapy massage for first applied in long sweeping strokes which warm up the skin, continue to Javanese scrub and mask for make skin are glow, to complete the treatment with signature facial, finishing with a flower bath and essential oil, to leave totally full body and face treatment. (foot wash, body massage, body scrub and mask, facial, flower bath)."
      },
      {
        name: "Tunjung Beauty",
        duration: "120 Minutes",
        price: "IDR 750K",
        description: "A indulge your body and soul in the in the nutritious and moisturizing with cocoa. Your chocolate sensation commences with balinese massage with chocolate oil, continue with chocolate body scrub and mask, finishing with a relaxing flower bath with chocolate bath salt and chocolate essential oil, to complete the treatment we serve hot chocolate. (Foot wash, aroma chocolate massage, chocolate scrub and mask, milk bath, hot chocolate drink)."
      },
      {
        name: "Patal Kikian Healing",
        duration: "120 Minutes",
        price: "IDR 950K",
        description: "A Patal kikian herbal massage a deep relaxation with hot compresses and classic techniques, while relieving stress and improving health, ingredient with herb and spice, following with a traditional boreh scrub and mask, a traditional flower bath with citrus will make a great your day, to complete the indulgent we serve the turmeric mix with honey and lime (foot wash, herbal massage, boreh scrub, boreh mask, flower bath, and herbal drink with turmeric, honey and lime)."
      }
    ]
  }
];
